export default [
    {
        path: 'alteracao-resultado-lancamento',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-alteracao-resultado-lancamento' */
            '@/views/exame-imagem/alteracao-resultado-lancamento/Index'
        ),
        redirect: 'alteracao-resultado-lancamento/index',
        children: [
            {
                name: 'exame-imagem-alteracao-resultado-lancamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-alteracao-resultado-lancamento' */
                    '@/views/exame-imagem/alteracao-resultado-lancamento/List.vue'
                ),
            },
            {
                name: 'exame-imagem-alteracao-resultado-lancamento-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-alteracao-resultado-lancamento' */
                    '@/views/exame-imagem/alteracao-resultado-lancamento/Form.vue'
                ),
            },
            {
                name: 'exame-imagem-alteracao-resultado-lancamento-edit',
                path: 'edit/:id',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-alteracao-resultado-lancamento' */
                    '@/views/exame-imagem/alteracao-resultado-lancamento/Form.vue'
                ),
            },
        ],
    },
]